import { IonButton, IonButtons, IonCard, IonCardContent, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonImg, IonInput, IonItem, IonLabel, IonMenuButton, IonPage, IonRow, IonSelect, IonSelectOption, IonTextarea, IonTitle, IonToolbar, useIonRouter, useIonToast, useIonViewDidEnter, useIonViewWillEnter } from '@ionic/react';
import { chevronBackOutline, peopleOutline } from 'ionicons/icons';
import React, { useEffect, useRef, useState } from 'react';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import { useAppContext } from '../AppProvider';
import Alert from '@mui/material/Alert';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { AlertTitle } from '@mui/material';

const KidCreate: React.FC = () => {
    const [DOBMonthDays, setDOBMonthDays] = useState<any>();
    const [DOBYears, setDOBYears] = useState<any>();

    const DOBMonthInputRef = useRef<any>();
    const DOBDayInputRef = useRef<any>();
    const DOBYearInputRef = useRef<any>();

    const router = useIonRouter();

    const { authKey, authenticateMember, setShowLoader, settings, monthNames, SWFullHorizLogo, SWTextDarkLogo, showToast } = useAppContext();

    //
    // Authenticate Member
    //
    useIonViewWillEnter(() => { 
        //setShowLoader(true);
        const authenticate = async () => {
            const authenticated = await authenticateMember();   
            if(!authenticated || authenticated.mt == '') router.push('/login', 'forward');
            else {
                /*window.setTimeout(() => {
                    setShowLoader(false);
                }, 1500);*/
            }
        };
        authenticate();
    }); 

    useEffect(() => {
        const today = new Date();
        const thisYear = today.getFullYear();
        let days = 31;

        // Populate DOB Days options
        const daysOptions = [];
        for(let day = 1; day <= days; day++) daysOptions.push(day.toString());
        setDOBMonthDays(daysOptions);

        // Populate DOB Years options
        const start = thisYear;
        const end = thisYear - 18;
        const yearsOptions = [];
        for(let y = start; y >= end; y--) yearsOptions.push(y);
        setDOBYears(yearsOptions);   
    }, []);

    const getDaysByMonth = () => {	
        const today = new Date();
        const thisYear = today.getFullYear();
        const yearSelect = DOBYearInputRef;
        const monthSelect = DOBMonthInputRef;
        const daySelect = DOBDayInputRef;
        const year = yearSelect.current.value;
        const month = monthSelect.current.value;
        const day = daySelect.current.value;
        let days = new Date(year, month, 0).getDate();
        if(year == '0000' || year === undefined || month == '00' || month === undefined) days = 31;
        const daysOptions = [];
        for(let d = 1; d <= days; d++) daysOptions.push(d);
        setDOBMonthDays(daysOptions);
    };  
    
    const insertKid = async (e: any) => {
        e.preventDefault();
        const form = e.target; 
        const formName = form.name;
        const btn: any = document.getElementById(formName + 'Submit');
        btn.innerHTML = 'Saving...';
        btn.setAttribute('disabled', '');
        const formData = new FormData(form);
        formData.append('mt', authKey.mt);

        try {
            const response = await fetch('https://api.besolowise.com/kids/insert/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            if(response.ok) {
                const obj = await response.json(); 

                //if(obj.success) router.push('/account/kid/edit/' + obj.kt, 'back');
                if(obj.success) {
                    form.reset();
                    router.push('/account/kids', 'forward');
                } else {
                    showToast({
                        message: 'Error: ' + obj.message,
                        duration: 5000,
                        color: 'danger',
                    });
                }
                btn.innerHTML = 'Save';
                btn.removeAttribute('disabled');                    
            } else {
                btn.innerHTML = 'Save';
                btn.removeAttribute('disabled');
                showToast({
                    message: 'Response Error',
                    duration: 2000,
                    color: 'danger',
                });
            } 
        } catch(error) {
            btn.innerHTML = 'Save';
            btn.removeAttribute('disabled');
            showToast({
                message: 'Connection Error: Couldn\'t create this kid. ' + error + '. Try again.',
                duration: 3000,
                color: 'danger',
                position: 'middle'
            });
        }          
    };


    const clearForm = () => {

    };

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot='start'>
                        <IonButton color={'tertiary'} routerDirection='back' routerLink='/account/kids'>Kids</IonButton>
                    </IonButtons>
                    <IonTitle><IonImg className='headerTextLogo' src={settings.theme == '1' ? SWTextDarkLogo : SWFullHorizLogo}></IonImg></IonTitle>
                    <IonButtons slot='end'>
                        <IonMenuButton color={'tertiary'} />
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding account-content-bg">
                <IonGrid>
                    <IonRow>
                        <IonCol size='12'>
                            <h1><IonIcon color={'secondary'} icon={peopleOutline}></IonIcon> New Kid<br /><span>Save details about your Kids</span></h1>
                        </IonCol>
                    </IonRow>
                </IonGrid>

                <IonCard>                    
                    <IonCardContent>    
                        <form name='kidForm' onSubmit={insertKid}>
                            <IonGrid>                                

                                <IonRow>
                                    <IonCol sizeXs='6' sizeSm='6'>
                                        <IonLabel color={'dark'}><b>First Name</b> <em className='required'>Required</em></IonLabel>
                                        <IonInput fill='outline' name='kidFirstName' placeholder='First name' type='text'></IonInput>
                                    </IonCol>
                                    <IonCol sizeXs='6' sizeSm='6'>
                                        <IonLabel color={'dark'}><b>Last Name</b> <em className='required'>Required</em></IonLabel>
                                        <IonInput fill='outline' name='kidLastName' placeholder='Last name' type='text'></IonInput>
                                    </IonCol>
                                </IonRow>

                                <IonRow>
                                    <IonCol sizeXs='12' sizeSm='6'>
                                        <IonLabel color={'dark'}><b>Race or skin tone</b></IonLabel>
                                        <IonInput fill='outline' name='kidRace' placeholder='Race or skin tone' type='text'></IonInput>
                                    </IonCol> 
                                </IonRow>

                                <IonRow>
                                    <IonCol size='12'>
                                        <IonLabel color={'dark'}><b>Gender</b></IonLabel>
                                    </IonCol>
                                    <IonCol sizeXs='12' sizeSm='6'>
                                        <IonSelect fill='outline' labelPlacement='stacked' name='kidGender' placeholder='Gender'>
                                            <IonSelectOption value='U'>I prefer not to say</IonSelectOption>
                                            <IonSelectOption value='F'>Female</IonSelectOption>
                                            <IonSelectOption value='M'>Male</IonSelectOption>
                                            <IonSelectOption value='O'>Non-binary</IonSelectOption>
                                        </IonSelect>
                                    </IonCol> 
                                </IonRow>

                                <IonRow>
                                    <IonCol size='12'>
                                        <IonLabel color={'dark'}><b>Date of Birth</b></IonLabel>
                                    </IonCol>
                                    <IonCol size='12' sizeSm='4'>
                                        <IonSelect fill='outline' labelPlacement='stacked' name='kidDOBYear' onIonChange={getDaysByMonth} placeholder='Year' ref={DOBYearInputRef}>                                     
                                            <IonSelectOption value='0000'>Year</IonSelectOption>
                                            {DOBYears !== undefined
                                                ? (DOBYears.map((year:string, index:number) => (
                                                    <IonSelectOption key={index} value={year}>{year}</IonSelectOption>
                                                  )))
                                                : (<></>)
                                            }
                                        </IonSelect>
                                    </IonCol> 
                                    <IonCol size='6' sizeSm='4'>
                                        <IonSelect fill='outline' labelPlacement='stacked' name='kidDOBMonth' onIonChange={getDaysByMonth} placeholder='Month' ref={DOBMonthInputRef}>                                     
                                            <IonSelectOption value='00'>Month</IonSelectOption>
                                            {monthNames.map((name:string, index:number) => (
                                                <IonSelectOption key={index} value={index < 9 ? `0${index + 1}` : `${index + 1}`}>{name}</IonSelectOption>
                                            ))}
                                        </IonSelect>
                                    </IonCol>
                                    <IonCol size='6' sizeSm='4'>
                                        <IonSelect fill='outline' labelPlacement='stacked' name='kidDOBDay' onIonChange={getDaysByMonth} placeholder='Day' ref={DOBDayInputRef}>                                     
                                            <IonSelectOption value='00'>Day</IonSelectOption>
                                            {DOBMonthDays !== undefined 
                                                ? (DOBMonthDays.map((day:string, index:number) => (
                                                    <IonSelectOption key={index} value={index < 9 ? `0${index + 1}` : `${index + 1}`}>{day}</IonSelectOption>
                                                  )))
                                                : (<></>)
                                            }
                                        </IonSelect>
                                    </IonCol>                                                                     
                                </IonRow>

                                <IonRow>
                                    <IonCol size='12'>
                                        <IonLabel color={'dark'}><b>Medical or Other Important Info</b></IonLabel>
                                    </IonCol>
                                    <IonCol size='12'>
                                        <IonTextarea fill='outline' name='kidMedical' placeholder='Medical History, Medications, Allergies, etc.'></IonTextarea>
                                        <p>This is not considered to be an official medical record. Please remember, others will see this if you don't check-in by your scheduled time.</p>
                                    </IonCol>
                                </IonRow>

                            </IonGrid>  

                            <IonButton className='ion-margin-top' color={'secondary'} expand="block" id='kidFormSubmit' type='submit'>Save</IonButton>
                        </form>
                    </IonCardContent>
                </IonCard>
            </IonContent>
        </IonPage>
    );
};

export default KidCreate;